'use client';

import { useCoinThresholds } from '@/features/coin-event/hooks/use-coin-thresholds';

import { useReward } from '@/contexts/reward-context';
import { useSabaCoinEvent } from '@/contexts/saba-coin-context';
import { ThresholdItem } from './threshold-item';

export const CoinEventThresholdList = () => {
	const { enableCoinEventUpdate } = useReward();
	const { sabaCoinEventInfo } = useSabaCoinEvent();
	const { 
		thresholds,
		achievedThreshold,
	} = useCoinThresholds();

	const sortedThresholds = [...thresholds].sort((a, b) => {
		if (a.IsRedeemed === b.IsRedeemed) {
			return a.ThresholdId - b.ThresholdId;
		}
		return Number(a.IsRedeemed) - Number(b.IsRedeemed);
	});
	
	return (
		<div className="shop-coin-list">
			{sortedThresholds.map(threshold => {
				return (
					<ThresholdItem 
						key={threshold.ThresholdId} 
						achievedThresholdId={achievedThreshold?.ThresholdId ?? 0}
						thresholdId={threshold.ThresholdId}
						thresholdAmount={threshold.ThresholdAmount}
						previousTurnOver={enableCoinEventUpdate ? threshold.PreviousTurnOver : 0}
						redeemablePrice={threshold.RedeemablePrice}
						requiredCoins={threshold.RequiredCoins}
						isRedeemed={threshold.IsRedeemed}
						weeklyBettingAmount={sabaCoinEventInfo.WeeklyBettingAmount}
					/>
				);
			})}
		</div>
	);
};